// extracted by mini-css-extract-plugin
export default {"frame":"ClientLogoList_frame__RjHJb"};